/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import { Box } from "@material-ui/core";
import { Grid, Paper } from "@mui/material";
import { toastr } from "react-redux-toastr";
import React, { useRef, useState } from "react";
import { useCallback, useEffect, useMemo } from "react";
// component
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import { checkIsStripe, checkIsTranzila } from "helper/checkIsStripe";
import { useMobileView } from "hook/mobileView/useMobileView";
import { getAccessTokenSilently } from "utils/functions";
import { postalCodeFormat } from "helper/postalCodeFormat";
// direct import
import OtpModal from "./OtpModal";
import Header from "./Header/Header";
import { CardContent, ImageCard } from "./Theme";
import { PaymentCard } from "./PaymentCard/PaymentCard";
import { ImageContainer } from "../MemberLink/PayFromExternalLink/Theme";

export const UpdatePayment = () => {
  const { isMobile } = useMobileView();
  const addCardStripeRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  const logo = localStorage.getItem("logoImgForm");
  const paymentMethod = JSON.parse(
    localStorage.getItem("paymentMethodCreditCard")
  );
  // state
  const [tempToken, setTempToken] = useState(null);
  const [verifyModal, setVerifyModal] = useState(true);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAchCard, setSelectedAchCard] = useState(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [achPaymentMethod, setAchPaymentMethod] = useState(null);
  const [addNewCard, setAddNewCard] = useState(false);

  const generateToken = async () => {
    const subDomain = window.location.hostname.split(".")[0];
    const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
    try {
      const res = await AuthService.generateToken(hostName);
      localStorage.setItem("FormToken", res?.token);
      localStorage.setItem("FormOrgId", res?._id);
      localStorage.setItem("logoImgForm", res?.logoImg);
      localStorage.setItem("orgName", res?.orgName);
      document.title = `${res?.orgName}`;
      localStorage.setItem("getOrginasitionBySubDomain", JSON.stringify(res));
      localStorage.setItem(
        "allowBillMyAccountOnDonation",
        res?.allowBillMyAccountOnDonation || false
      );
      localStorage.setItem("country", JSON.stringify(res?.country || {}));
      localStorage.setItem(
        "allowInstallments",
        res?.allowInstallments || false
      );
      localStorage.setItem("orgHasPayment", res?.hasPayment || false);

      localStorage.setItem(
        "paymentMethodCreditCard",
        JSON.stringify(res?.paymentMethodCreditCard)
      );
      setAchPaymentMethod(res?.paymentMethodAch);
      localStorage.setItem(
        "paymentMethodAch",
        JSON.stringify(res?.paymentMethodAch)
      );
      localStorage.setItem(
        "memberSetting",
        JSON.stringify(res?.memberSetting || {})
      );
      localStorage.setItem(
        "memberPortalDirectory",
        JSON.stringify(res?.memberPortalDirectory || false)
      );
      setTempToken(res);
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    generateToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      errors: [],
      selectedCard: null,
      selectedAchCard: null,
      dropdowns: [],
      accountInfo: {},
      cardsDetails: {
        zip: "",
        expMonth: "",
        card_number: "",
        expYear: "",
        cvc: "",
      },
      activePayment: "credit-card",
      tokenForOneHour: "",
      listAch: {},
      listCards: {},
      captchaValue: null,
      saveCard: false,
      isStripe: false,
      addCard: false,
      addCardError: null,
      cardLoading: false,
    },
    onSubmit: async (values) => {
      formik.setFieldValue("cardLoading", true);

      if (values?.isStripe) {
        const tokenId = await addCardStripeRef?.current?.handleGetToken();
        if (tokenId && tokenId !== null) {
          await handleSubmit(tokenId, values);
        }
      } else {
        await handleSubmit(null, values);
      }
      formik.setFieldValue("cardLoading", null);
    },
  });

  const handleSubmit = async (tokenId = "", values) => {
    const { card_number, expMonth, expYear, cvc, zip } = values?.cardsDetails;

    const token = await getAccessTokenSilently();
    const cardDetails = {
      object: "card",
      number: card_number?.replace(/\s/g, ""),
      exp_month: expMonth,
      exp_year: expYear,
      cvc: cvc,
      zip: zip,
    };
    if (
      !isStripe &&
      (!cardDetails?.number ||
        !cardDetails?.exp_month ||
        !cardDetails?.exp_year ||
        !cardDetails?.cvc ||
        !cardDetails?.zip)
    ) {
      formik.setFieldValue("cardLoading", null);
      formik.setFieldValue(
        "addCardError",
        "All card details fields are required"
      );
      setTimeout(() => {
        formik.setFieldValue("addCardError", null);
      }, 4000);

      return;
    }
    const validZipCode = postalCodeFormat(zip);
    if (!isStripe && !validZipCode) {
      formik.setFieldValue("cardLoading", null);
      formik.setFieldValue("addCardError", `Invalid postalCode Label`);
      setTimeout(() => {
        formik.setFieldValue("addCardError", null);
      }, 4000);
      return;
    }
    const bodyData = {};
    if (isStripe && tokenId) {
      bodyData.token = tokenId;
    } else {
      bodyData.cardsDetails = cardDetails;
    }
    const accountID = localStorage.getItem("accountID");
    await AuthService.addCard(
      bodyData,
      token,
      values?.accountInfo?.main_contact?.account_id ?? accountID
    )
      .then((res) => {
        if (res) {
          setAddNewCard(false);
          getCreditCards(values?.accountInfo);
          toastr.success("Success", "Card has been added successfully ");
          formik.setFieldValue("cardLoading", false);
          if (!isStripe) {
            formik.setFieldValue("cardsDetails", {
              zip: "",
              expMonth: "",
              card_number: "",
              expYear: "",
              cvc: "",
            });
          }
        }
      })
      .catch((err) => {
        formik.setFieldValue("addCardError", err?.data?.message);
        formik.setFieldValue("cardLoading", false);
        setTimeout(() => {
          formik.setFieldValue("addCardError", null);
        }, 4000);
      });
    formik.setFieldValue("cardLoading", null);
  };

  useEffect(() => {
    formik.setFieldValue("selectedCard", selectedCard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCard]);

  useEffect(() => {
    formik.setFieldValue("selectedAchCard", selectedAchCard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAchCard]);

  const getCurrentPaymentMethod = useCallback(() => {
    if (formik?.values?.activePayment === "credit-card") {
      return paymentMethod;
    }
    if (formik?.values?.activePayment === "ach") {
      return achPaymentMethod;
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const currentPaymentMethod = useMemo(() => getCurrentPaymentMethod(), [
    getCurrentPaymentMethod,
  ]);

  const isStripe = useMemo(() => checkIsStripe(currentPaymentMethod), [
    currentPaymentMethod,
  ]);

  useEffect(() => {
    formik.setFieldValue("isStripe", isStripe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStripe]);

  const getCreditCards = async (accountInfo) => {
    setCardLoading(true);
    const token = await getAccessTokenSilently();

    const data = await FinanceService.getCreditCardsByAccountId(
      token,
      accountInfo?._id
    );
    formik.setFieldValue("listCards", data?.card?.data);
    if (data?.card?.data?.length > 0) {
      const cardSelected = data?.card?.data?.find((el) => el?.is_default)?.id;
      const cardConfirmed = cardSelected ?? data?.card?.data?.[0]?.id;
      formik.setFieldValue("selectedCard", cardConfirmed);
      setSelectedCard(cardConfirmed);
    }
    setCardLoading(false);
  };

  const onHandleSubmit = (data) => {
    formik.setFieldValue("accountInfo", data?.accountInfo);
    formik.setFieldValue("tokenForOneHour", data?.tokenForOneHour);
    getCreditCards(data?.accountInfo);
    localStorage.setItem("token", data?.tokenForOneHour);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header Logo={logo} />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ p: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12}>
                <Paper
                  sx={{
                    height: isMobile ? "165px" : "227px",
                    borderRadius: "10px",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "#1A2027" : "#2555EF",
                  }}
                >
                  <ImageContainer isMobile={isMobile}>
                    <CardContent isMobile={isMobile}>
                      <h1>
                        {formik?.values?.accountInfo?.family_name}
                      </h1>
                      <p>
                        Please update your payment method in the section below.
                      </p>
                      <span>ID #{formik?.values?.accountInfo?.account_id}</span>
                    </CardContent>
                    <div>
                      <ImageCard isMobile={isMobile} />
                    </div>
                  </ImageContainer>
                </Paper>
              </Grid>
              <Grid item xs={12} lg={6}>
                {!verifyModal && (
                  <PaymentCard
                    formik={formik}
                    isStripe={isStripe}
                    addCardStripeRef={addCardStripeRef}
                    setSelectedCard={setSelectedCard}
                    selectedCard={selectedCard}
                    setSelectedAchCard={setSelectedAchCard}
                    selectedAchCard={selectedAchCard}
                    publicKey={
                      currentPaymentMethod?.paymentGateway?.keys?.publicKey
                    }
                    getCreditCards={getCreditCards}
                    cardLoading={cardLoading}
                    setAddNewCard={setAddNewCard}
                    addNewCard={addNewCard}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <OtpModal
        open={verifyModal}
        handleClose={() => {}}
        setVerifyModal={setVerifyModal}
        onHandleSubmit={onHandleSubmit}
        tempToken={tempToken}
      />
    </>
  );
};
